export default __webpack_public_path__ + "static/media/photo10.4f4b7375.jpg";